package com.example.hukakmp.model

import dev.gitlive.firebase.firestore.Timestamp
import kotlinx.serialization.Serializable

@Serializable
data class PescadexSpeciesInfo(
    val id: String = "",
    val nombreComun: String = "",
    val nombreCientifico: String = "",
    val habitat: String = "",
    val mejoresCarnadas: List<String> = emptyList(),
    val mejorHorario: String = "",
    val tecnica: String = "",
    val tamano: String = "",
    val temporada: String = "",
    val rareza: String = "comun",
)

@Serializable
data class EspecieDescubierta(
    val especieId: String = "",
    val nombreComun: String = "",
    val nombreCientifico: String = "",
    val fechaDescubrimiento: Timestamp? = null,
    val totalCapturas: Int = 0,
    val pesoRecord: Double? = null,
    val primeraFoto: String? = null,
    val locaciones: List<String> = emptyList(),
    val rareza: String = "comun",
    val mejorDiaFecha: String? = null,
    val mejorDiaCantidad: Int = 0,
)

@Serializable
data class PescadexUsuario(
    val deviceId: String = "",
    val especiesDescubiertas: Map<String, EspecieDescubierta> = emptyMap(),
    val fechaInicio: Timestamp? = null,
    val ultimaActividad: Timestamp? = null,
    val logrosDesbloqueados: List<String> = emptyList(),
)

data class EspecieConEstado(
    val info: PescadexSpeciesInfo,
    val esCapturada: Boolean,
    val datosCaptura: EspecieDescubierta?,
)

data class EstadisticasPescadex(
    val especiesDescubiertas: Int = 0,
    val totalEspecies: Int = 0,
    val totalCapturas: Int = 0,
) {
    val porcentajeCompletado: Float
        get() = if (totalEspecies == 0) 0f else especiesDescubiertas * 100f / totalEspecies
}
